import axios from "axios"

/**
 * Image sizes available
 */
export enum ImageSize {
  thumbnail= 'thumbnail',
  medium = 'medium',
  large = 'large',
  original = 'original',
}

/**
 * Get file URL for viewing/displaying (not downloading)
 */
export function fileUrl(id: number, size: ImageSize = ImageSize.original): string {
  return `/files/${id}/${size}`
}

export function assetUrl(id: number, size: ImageSize = ImageSize.original): string {
  // return `/api/v1/files/${id}/${size}`
  return `${import.meta.env.VITE_API_BASE_URL}/files/${id}/${size}`
}

/**
 * Download file with proper filename preservation
 * Fetches file metadata first to get the correct filename, then downloads
 * 
 * @param id - The file ID to download
 */
export async function downloadFile(id: number): Promise<any> {
  // First, fetch the file metadata to get the correct filename
  const { data } = await axios.get(`/files/view/${id}`)
  const fileName = data.file.name
  
  // Now download the file and use the correct filename
  // Cast to any to bypass TypeScript limitations on the download method signature
  return (axios as any).download(`/files/${id}/download`, {}, 'get', fileName)
}
